// extracted by mini-css-extract-plugin
module.exports = {"content":"Description_content__cb2Ef","wrapper":"Description_wrapper__3YAk0"};